import * as React from 'react';
import { PriceAdjustmentViewModel, EmployeeDiscountViewModel } from '@models/Product';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';

export interface CoverageCalcuationComponentProperties {
  readonly sellerCoverage: boolean;
  readonly buyerTotalPrice: number;
  readonly sellerTotalPrice: number;
  readonly priceAdjustment?: PriceAdjustmentViewModel;
  readonly totalPrice: number;
  readonly employeeDiscounts: Array<EmployeeDiscountViewModel>;
  readonly extraCharge: number;
  readonly overridePriceAdjustmentAmount?: number;
  readonly totalAdjustment: number;
  readonly employeeDiscount?: EmployeeDiscountViewModel;
}

export class CoverageCalcuationComponent extends React.Component<CoverageCalcuationComponentProperties> {
  renderPriceAdjustment = () => {
    if (!this.props.priceAdjustment || this.props.priceAdjustment.id === -1) {
      return null;
    }

    if (this.props.priceAdjustment.increase && this.props.totalAdjustment !== 0) {
      return <h3> Total Surcharge ${Math.abs(this.props.totalAdjustment).toFixed(2)}</h3>;
    }

    let employeeDiscountAmount = 0;
    if (this.props.priceAdjustment && this.props.employeeDiscount && this.props.employeeDiscount.id > 0) {
      employeeDiscountAmount = -(
        (this.props.totalPrice - this.props.priceAdjustment.adjustmentAmount) *
        this.props.employeeDiscount.percentageAmount
      );
    }
    if (this.props.totalAdjustment + employeeDiscountAmount === 0) {
      return null;
    }
    return (
      <h3>
        {' '}
        Total Discount: $-
        {Math.abs(
          employeeDiscountAmount
            ? -this.props.priceAdjustment.adjustmentAmount + employeeDiscountAmount
            : this.props.totalAdjustment
        ).toFixed(2)}
      </h3>
    );
  };
  // comment here

  calculateTotalPrice = () => {
    let adjustmentAmount = 0;

    if (this.props.priceAdjustment) {
      const sign = this.props.priceAdjustment.increase ? 1 : -1;
      let adjustmentValue = sign * this.props.priceAdjustment.adjustmentAmount;
      if (this.props.overridePriceAdjustmentAmount !== undefined) {
        adjustmentValue = sign * Math.abs(this.props.overridePriceAdjustmentAmount);
      }
      adjustmentAmount = adjustmentValue;
    }

    let employeeDiscountAmount = 0;
    if (this.props.employeeDiscount && this.props.employeeDiscount.id > 0) {
      employeeDiscountAmount = -(
        (this.props.totalPrice + adjustmentAmount) *
        this.props.employeeDiscount.percentageAmount
      );
    }
    let result = this.props.totalPrice + adjustmentAmount + employeeDiscountAmount;
    if (this.props.extraCharge !== 0) {
      result += this.props.extraCharge;
    }
    return result.toFixed(2);
  };
  render() {
    return (
      <div className="row end-xs">
        <div className="col-md">
          {this.props.sellerCoverage ? (
            <>
              <h3> Total Buyer Price: ${this.props.buyerTotalPrice.toFixed(2)}</h3>
              <h3>
                <TooltipComponent
                  text="Per diem prices are calculated based on 180 days until COE is added"
                  side="left"
                  relative={true}
                  absoluteText={true}
                />
                Total Seller Price: ${this.props.sellerTotalPrice.toFixed(2)}
              </h3>
            </>
          ) : this.props.priceAdjustment ? (
            <>
              <h3>Subtotal: ${this.props.totalPrice.toFixed(2)}</h3>
            </>
          ) : (
            <></>
          )}
          {this.renderPriceAdjustment()}
          {this.props.extraCharge !== 0 && <h3> Extra Charge ${this.props.extraCharge.toFixed(2)}</h3>}
          <hr />
          <h3> Total: ${this.calculateTotalPrice()}</h3>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/coverage-calculation.component.tsx